import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/catch';

import { NzMessageService } from "ng-zorro-antd";
import { GetSessionStore } from "./comment";
@Injectable()
export class HttpServer {
  constructor(public http: HttpClient, private msg: NzMessageService) { }
  post(url, params): Observable<any> {
    let successLoginInfo = JSON.parse(GetSessionStore("successLoginInfo"));
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': '	application/json' })
    };
    params = this.param(params);
    return this.http.post(url, params, httpOptions)
      .map((res) => {
        return res;
      })
      .filter((value: any) => {
        return value;
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));



  }
  /**
   * @param {any} data
   * @returns
   * @memberof ServiceBaseService
   * @title:封装一个序列化get请求的参数的方法
   */
  param(data): string {
    let url = '';
    // tslint:disable-next-line:forin
    for (const k in data) {
      const value = data[k] !== undefined ? data[k] : '';
      url += `&${k}=${encodeURIComponent(value)}`;
    }
    return url ? url.substring(1) : '';
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/services/sie.httpBase.ts